export default "__VITE_ASSET__C_UY1iiT__"